export const SITE_URL = 'https://swapify.nl';

export const TRUST_BAR_ITEMS = [
  '🔒 Veilig betalen via iDEAL',
  '✓ Elke bon geverifieerd',
  '📧 Code na verificatie per e-mail',
  '🛡️ 12 uur kopersbescherming',
];

export const HOMEPAGE_BRANDS = [
  {
    label: 'Albert Heijn',
    logoBrand: 'Albert Heijn',
    text: 'Bespaar op je boodschappen',
    cta: 'Bekijk aanbod →',
    to: '/giftcards/albert-heijn',
  },
  {
    label: 'bol',
    logoBrand: 'Bol.com',
    text: 'Boeken, tech, speelgoed en meer — met korting',
    cta: 'Bekijk aanbod →',
    to: '/giftcards/bol-com',
  },
  {
    label: 'Coolblue',
    logoBrand: 'Coolblue',
    text: 'Alles voor een glimlach, alleen dan voordeliger',
    cta: 'Bekijk aanbod →',
    to: '/giftcards/coolblue',
  },
  {
    label: 'Douglas',
    logoBrand: 'Douglas',
    text: 'Beauty en parfum voor minder',
    cta: 'Bekijk aanbod →',
    to: '/giftcards/douglas',
  },
];

export const BRAND_LANDING_PAGES = [
  {
    slug: 'albert-heijn',
    brand: 'Albert Heijn',
    displayBrand: 'Albert Heijn',
    path: '/giftcards/albert-heijn',
    marketplacePath: '/marketplace?brand=Albert%20Heijn',
    title: 'Albert Heijn Cadeaukaart met Korting Kopen of Verkopen | Swapify',
    description: 'Koop een Albert Heijn cadeaukaart met korting of verkoop je ongebruikte AH bon via Swapify. Veilig via iDEAL, code na verificatie per e-mail.',
    heroTitle: 'Bespaar op je boodschappen',
    heroText: 'Koop een Albert Heijn cadeaukaart met korting. Of verkoop je ongebruikte bon en laat je uitbetalen.',
    primaryCtaLabel: 'Bekijk AH aanbod',
    secondaryCtaLabel: 'Bon verkopen',
    steps: [
      {
        title: 'Kies een AH cadeaukaart',
        text: 'Bekijk het aanbod Albert Heijn cadeaukaarten en kies de waarde die bij je past.',
      },
      {
        title: 'Betaal veilig via iDEAL',
        text: 'Reken af met iDEAL. Je betaling blijft beschermd totdat je de bon hebt gecheckt.',
      },
      {
        title: 'Ontvang je code',
        text: 'Na verificatie ontvang je de code per e-mail. Bruikbaar in de winkel en op ah.nl.',
      },
      {
        title: 'Check binnen 12 uur',
        text: 'Test de code bij Albert Heijn. Werkt het niet? Dan krijg je je geld terug.',
      },
    ],
    buyPoints: [
      'Korting op je AH cadeaukaart',
      'Bruikbaar in de winkel en op ah.nl',
      'Veilig betalen via iDEAL',
      '12 uur kopersbescherming op elke aankoop',
    ],
    sellPoints: [
      'Maak van je ongebruikte AH bon geld',
      'Gratis aanmelden, geen verborgen kosten',
      'Bepaal zelf je verkoopprijs',
      'Uitbetaling na de verificatieperiode',
    ],
    faq: [
      {
        question: 'Hoe koop ik een Albert Heijn cadeaukaart met korting?',
        answer: 'Kies een AH cadeaukaart op onze marktplaats, betaal veilig via iDEAL en ontvang de code na verificatie per e-mail. Daarna kun je de bon gebruiken in de winkel of op ah.nl.',
      },
      {
        question: 'Kan ik mijn AH cadeaukaart verkopen op Swapify?',
        answer: 'Ja. Maak gratis een account aan, vul je kaartgegevens in en bepaal je prijs. Na verificatie door ons team komt je bon live op het platform.',
      },
      {
        question: 'Hoe weet ik dat de AH code werkt?',
        answer: 'Elke cadeaubon wordt door ons team gecontroleerd voordat deze live gaat. Na aankoop heb je 12 uur om de code te checken. Werkt het niet? Dan krijg je je geld terug.',
      },
    ],
    bottomCtaTitle: 'Klaar om te besparen op je boodschappen?',
    bottomCtaText: 'Bekijk het aanbod AH cadeaukaarten of verkoop je ongebruikte bon.',
  },
  {
    slug: 'bol-com',
    brand: 'Bol.com',
    displayBrand: 'bol',
    path: '/giftcards/bol-com',
    marketplacePath: '/marketplace?brand=Bol.com',
    title: 'bol Cadeaukaart met Korting Kopen of Verkopen | Swapify',
    description: 'Koop een bol cadeaukaart met korting of verkoop je ongebruikte bol bon via Swapify. Veilig via iDEAL, code na verificatie per e-mail.',
    heroTitle: 'Shop slimmer op bol',
    heroText: 'Koop een bol cadeaukaart met korting. Of verkoop je ongebruikte bon eenvoudig via Swapify.',
    primaryCtaLabel: 'Bekijk bol aanbod',
    secondaryCtaLabel: 'Bon verkopen',
    steps: [
      {
        title: 'Kies een bol cadeaukaart',
        text: 'Bekijk het aanbod en kies de waarde die bij je past.',
      },
      {
        title: 'Betaal veilig via iDEAL',
        text: 'Reken af met iDEAL. Je betaling blijft beschermd totdat je de bon hebt gecheckt.',
      },
      {
        title: 'Ontvang je code',
        text: 'Na verificatie ontvang je de code per e-mail. Klaar om te gebruiken bij het afrekenen op bol.',
      },
      {
        title: 'Check binnen 12 uur',
        text: 'Test de code op bol. Werkt het niet? Dan krijg je je geld terug.',
      },
    ],
    buyPoints: [
      'Korting op je bol cadeaukaart',
      'Bruikbaar voor boeken, elektronica, speelgoed en meer',
      'Veilig betalen via iDEAL',
      '12 uur kopersbescherming op elke aankoop',
    ],
    sellPoints: [
      'Zet je ongebruikte bol bon om in geld',
      'Gratis aanmelden, geen verborgen kosten',
      'Bepaal zelf je verkoopprijs',
      'Uitbetaling na de verificatieperiode',
    ],
    faq: [
      {
        question: 'Hoe koop ik een bol cadeaukaart met korting?',
        answer: 'Kies een bol cadeaukaart op Swapify, betaal via iDEAL en ontvang de code na verificatie per e-mail. Je kunt de code daarna gebruiken bij het afrekenen op bol.',
      },
      {
        question: 'Kan ik mijn bol cadeaukaart verkopen?',
        answer: 'Ja. Upload je kaartgegevens, stel je prijs in en wij regelen de rest. Na verificatie en verkoop ontvang je je uitbetaling.',
      },
      {
        question: 'Hoe weet ik dat de bol code werkt?',
        answer: 'Wij controleren het saldo van elke cadeaubon voordat deze op het platform komt. Na aankoop heb je 12 uur om de code te checken.',
      },
    ],
    bottomCtaTitle: 'Klaar om slimmer te shoppen op bol?',
    bottomCtaText: 'Bekijk het aanbod bol cadeaukaarten of verkoop je ongebruikte bon.',
  },
  {
    slug: 'coolblue',
    brand: 'Coolblue',
    displayBrand: 'Coolblue',
    path: '/giftcards/coolblue',
    marketplacePath: '/marketplace?brand=Coolblue',
    title: 'Coolblue Cadeaukaart met Korting Kopen of Verkopen | Swapify',
    description: 'Koop een Coolblue cadeaukaart met korting of verkoop je ongebruikte Coolblue bon via Swapify. Veilig via iDEAL, code na verificatie per e-mail.',
    heroTitle: 'Alles voor een glimlach. Alleen dan voordeliger.',
    heroText: 'Koop een Coolblue cadeaukaart met korting. Of verkoop je ongebruikte bon en laat je uitbetalen.',
    primaryCtaLabel: 'Bekijk Coolblue aanbod',
    secondaryCtaLabel: 'Bon verkopen',
    steps: [
      {
        title: 'Kies een Coolblue cadeaukaart',
        text: 'Bekijk het aanbod en kies de waarde die bij je past.',
      },
      {
        title: 'Betaal veilig via iDEAL',
        text: 'Reken af met iDEAL. Je betaling blijft beschermd totdat je de bon hebt gecheckt.',
      },
      {
        title: 'Ontvang je code',
        text: 'Na verificatie ontvang je de code per e-mail. Bruikbaar op coolblue.nl.',
      },
      {
        title: 'Check binnen 12 uur',
        text: 'Test de code bij Coolblue. Werkt het niet? Dan krijg je je geld terug.',
      },
    ],
    buyPoints: [
      'Korting op je Coolblue cadeaukaart',
      'Bruikbaar voor elektronica, huishoudelijke apparaten en meer',
      'Veilig betalen via iDEAL',
      '12 uur kopersbescherming op elke aankoop',
    ],
    sellPoints: [
      'Maak van je ongebruikte Coolblue bon geld',
      'Gratis aanmelden, geen verborgen kosten',
      'Bepaal zelf je verkoopprijs',
      'Uitbetaling na de verificatieperiode',
    ],
    faq: [
      {
        question: 'Hoe koop ik een Coolblue cadeaukaart met korting?',
        answer: 'Kies een Coolblue cadeaukaart op Swapify, betaal via iDEAL en ontvang de code na verificatie per e-mail. Daarna kun je de bon gebruiken op coolblue.nl.',
      },
      {
        question: 'Kan ik mijn Coolblue cadeaukaart verkopen?',
        answer: 'Zeker. Meld je aan, vul je kaartgegevens in en bepaal je prijs. Wij controleren de bon en na verkoop ontvang je je uitbetaling.',
      },
      {
        question: 'Wat als de Coolblue code niet werkt?',
        answer: 'Na aankoop heb je 12 uur om de code te testen. Werkt de bon niet? Meld het dan bij ons en je krijgt je geld terug.',
      },
    ],
    bottomCtaTitle: 'Klaar om te besparen bij Coolblue?',
    bottomCtaText: 'Bekijk het aanbod Coolblue cadeaukaarten of verkoop je ongebruikte bon.',
  },
  {
    slug: 'douglas',
    brand: 'Douglas',
    displayBrand: 'Douglas',
    path: '/giftcards/douglas',
    marketplacePath: '/marketplace?brand=Douglas',
    title: 'Douglas Cadeaukaart met Korting Kopen of Verkopen | Swapify',
    description: 'Koop een Douglas cadeaukaart met korting of verkoop je ongebruikte Douglas bon via Swapify. Veilig via iDEAL, code na verificatie per e-mail.',
    heroTitle: 'Je favoriete beauty, maar dan voordeliger',
    heroText: 'Koop een Douglas cadeaukaart met korting. Of verkoop je ongebruikte bon eenvoudig via Swapify.',
    primaryCtaLabel: 'Bekijk Douglas aanbod',
    secondaryCtaLabel: 'Bon verkopen',
    steps: [
      {
        title: 'Kies een Douglas cadeaukaart',
        text: 'Bekijk het aanbod en kies de waarde die bij je past.',
      },
      {
        title: 'Betaal veilig via iDEAL',
        text: 'Reken af met iDEAL. Je betaling blijft beschermd totdat je de bon hebt gecheckt.',
      },
      {
        title: 'Ontvang je code',
        text: 'Na verificatie ontvang je de code per e-mail. Bruikbaar in de winkel en op douglas.nl.',
      },
      {
        title: 'Check binnen 12 uur',
        text: 'Test de code bij Douglas. Werkt het niet? Dan krijg je je geld terug.',
      },
    ],
    buyPoints: [
      'Korting op je Douglas cadeaukaart',
      'Bruikbaar voor parfum, make-up, skincare en meer',
      'Veilig betalen via iDEAL',
      '12 uur kopersbescherming op elke aankoop',
    ],
    sellPoints: [
      'Zet je ongebruikte Douglas bon om in geld',
      'Gratis aanmelden, geen verborgen kosten',
      'Bepaal zelf je verkoopprijs',
      'Uitbetaling na de verificatieperiode',
    ],
    faq: [
      {
        question: 'Hoe koop ik een Douglas cadeaukaart met korting?',
        answer: 'Kies een Douglas cadeaukaart op Swapify, betaal via iDEAL en ontvang de code na verificatie per e-mail. Daarna kun je de bon gebruiken in de winkel of op douglas.nl.',
      },
      {
        question: 'Kan ik mijn Douglas cadeaukaart verkopen?',
        answer: 'Ja. Meld je aan op Swapify, vul je kaartgegevens in en wij doen de rest. Na verificatie en verkoop ontvang je je uitbetaling.',
      },
      {
        question: 'Worden Douglas cadeaukaarten geverifieerd?',
        answer: 'Ja. Ons team controleert het saldo van elke bon voordat deze live gaat. Na aankoop heb je 12 uur om de code te testen.',
      },
    ],
    bottomCtaTitle: 'Klaar om te besparen bij Douglas?',
    bottomCtaText: 'Bekijk het aanbod Douglas cadeaukaarten of verkoop je ongebruikte bon.',
  },
];

export const GENERIC_LANDING_PAGES = [
  {
    slug: 'cadeaubonnen-kopen',
    path: '/cadeaubonnen-kopen',
    title: 'Cadeaubonnen Kopen met Korting | Swapify',
    description: 'Koop cadeaubonnen van populaire winkels met korting via Swapify. Albert Heijn, bol, Coolblue en Douglas. Veilig via iDEAL, code na verificatie per e-mail.',
    heroTitle: 'Cadeaubonnen kopen met korting',
    heroText: 'Bespaar op cadeaukaarten van populaire winkels. Veilig betalen via iDEAL, code na verificatie per e-mail.',
    primaryCta: { to: '/marketplace', label: 'Bekijk het aanbod' },
    introText: 'Op Swapify koop je cadeaukaarten van populaire winkels voor minder dan de winkelwaarde. Andere mensen verkopen hun ongebruikte bonnen, jij profiteert van de korting. Elke cadeaubon wordt door ons team gecontroleerd voordat deze live gaat. Je betaling blijft beschermd totdat je de code hebt gecheckt.',
    brands: [
      { label: 'Albert Heijn', text: 'Bespaar op je boodschappen', to: '/giftcards/albert-heijn' },
      { label: 'bol', text: 'Boeken, tech en meer — met korting', to: '/giftcards/bol-com' },
      { label: 'Coolblue', text: 'Alles voor een glimlach, alleen dan voordeliger', to: '/giftcards/coolblue' },
      { label: 'Douglas', text: 'Beauty en parfum voor minder', to: '/giftcards/douglas' },
    ],
    benefits: [
      'Korting op cadeaukaarten van populaire winkels',
      'Elke bon wordt gecontroleerd door ons team',
      'Veilig betalen via iDEAL',
      '12 uur kopersbescherming: werkt de code niet, geld terug',
      'Code na verificatie per e-mail',
    ],
    steps: [
      {
        title: 'Kies een cadeaubon',
        text: 'Bekijk het aanbod en kies een cadeaukaart met korting.',
      },
      {
        title: 'Betaal veilig',
        text: 'Reken af met iDEAL. Je geld blijft beschermd totdat je de bon hebt gecheckt.',
      },
      {
        title: 'Gebruik je code',
        text: 'Na verificatie ontvang je de code per e-mail. Klaar om te gebruiken in de winkel of online.',
      },
    ],
    faq: [
      {
        question: 'Hoe koop ik cadeaubonnen met korting?',
        answer: 'Ga naar de Swapify marktplaats, kies een cadeaukaart en betaal via iDEAL. Na verificatie ontvang je de code per e-mail.',
      },
      {
        question: 'Waarom zijn de cadeaubonnen goedkoper?',
        answer: 'Andere mensen verkopen hun ongebruikte cadeaubonnen op Swapify. Omdat zij liever geld ontvangen, bieden ze hun bon aan met korting. Jij profiteert daarvan.',
      },
      {
        question: 'Wat als de code niet werkt?',
        answer: 'Meld het binnen 12 uur via hello@swapify.nl. We onderzoeken je melding en als het nodig is, vergoeden we je aankoop volledig.',
      },
      {
        question: 'Welke merken zijn beschikbaar?',
        answer: 'Op dit moment werken we met een beperkt aantal merken. We breiden het aanbod stap voor stap uit. Wil je een merk laten toevoegen? Laat het ons weten via hello@swapify.nl.',
      },
    ],
    bottomCtaTitle: 'Klaar om te besparen?',
    bottomCtaText: 'Bekijk het aanbod cadeaukaarten met korting.',
    bottomCtaLabel: 'Naar de marktplaats',
    bottomCtaTo: '/marketplace',
  },
  {
    slug: 'cadeaubonnen-verkopen',
    path: '/cadeaubonnen-verkopen',
    title: 'Cadeaubonnen Verkopen voor Geld | Swapify',
    description: 'Verkoop je ongebruikte cadeaubonnen via Swapify. Albert Heijn, bol, Coolblue en Douglas. Gratis aanmelden, eenvoudig aanbieden en veilig uitbetaald.',
    heroTitle: 'Leuk, zo’n cadeaubon. Nog leuker als je er geld van maakt.',
    heroText: 'Verkoop je ongebruikte cadeaubon via Swapify. Gratis aanmelden, simpel geregeld en veilig uitbetaald.',
    primaryCta: { to: '/sell', label: 'Start met verkopen' },
    introText: 'Cadeaubon gekregen die je niet gaat gebruiken? Op Swapify verkoop je je cadeaubon aan iemand die er wél blij mee is. Jij bepaalt je prijs, wij regelen de controle en de betaling. Je bon is in een paar minuten aangemeld en gaat na verificatie live.',
    brands: [
      { label: 'Albert Heijn', text: 'Verkoop je AH bon', to: '/giftcards/albert-heijn' },
      { label: 'bol', text: 'Verkoop je bol bon', to: '/giftcards/bol-com' },
      { label: 'Coolblue', text: 'Verkoop je Coolblue bon', to: '/giftcards/coolblue' },
      { label: 'Douglas', text: 'Verkoop je Douglas bon', to: '/giftcards/douglas' },
    ],
    benefits: [
      'Gratis aanmelden, geen verborgen kosten',
      'Bepaal zelf je verkoopprijs',
      'Eenvoudig je listing aanmaken',
      'Veilige uitbetaling na de verificatieperiode',
      'Transparant: je ziet vooraf wat je ontvangt na kosten',
    ],
    steps: [
      {
        title: 'Maak een account aan',
        text: 'Meld je gratis aan en bevestig je e-mailadres.',
      },
      {
        title: 'Vul je bon in',
        text: 'Kies het merk, vul de waarde en kaartgegevens in en upload een foto van de bon.',
      },
      {
        title: 'Wij controleren je bon',
        text: 'Ons team controleert de bon en zet de bon na verificatie live op de marktplaats.',
      },
      {
        title: 'Ontvang je uitbetaling',
        text: 'Zodra je bon is verkocht en de verificatieperiode is verstreken, regelen wij je uitbetaling.',
      },
    ],
    faq: [
      {
        question: 'Hoe verkoop ik mijn cadeaubon op Swapify?',
        answer: 'Maak gratis een account aan, vul de kaartgegevens in, bepaal je prijs en upload een foto. Na verificatie door ons team komt je bon live op het platform.',
      },
      {
        question: 'Wat kost het om te verkopen op Swapify?',
        answer: 'Aanmelden is gratis. Bij een succesvolle verkoop betaal je 4,5% platformkosten en €0,28 iDEAL transactiekosten. Je ziet vooraf precies wat je ontvangt.',
      },
      {
        question: 'Hoe snel krijg ik mijn geld?',
        answer: 'We maken binnen 24 uur na verificatie het geld over naar je rekening.',
      },
      {
        question: 'Welke cadeaubonnen kan ik verkopen?',
        answer: 'Op dit moment werken we met een beperkt aantal merken. We breiden het aanbod stap voor stap uit. Wil je een merk laten toevoegen? Laat het ons weten via hello@swapify.nl.',
      },
    ],
    bottomCtaTitle: 'Die cadeaubon gaat zichzelf niet verkopen',
    bottomCtaText: 'Maak een account aan en zet je bon eenvoudig online.',
    bottomCtaLabel: 'Start met verkopen',
    bottomCtaTo: '/sell',
  },
];

export function getBrandLandingPage(brand) {
  return BRAND_LANDING_PAGES.find((page) => page.brand === brand) || null;
}

export function getCanonicalUrl(pathname) {
  return `${SITE_URL}${pathname}`;
}
